import {
  createCollectionURL,
  DELETE_ASSETS_FOR_EVER,
  DELETE_MULTIPLE_ASSET,
  ListofCollectionsURL,
} from 'components/Dam/DAM_API/urls';
import { DAM_SVG } from 'components/Dam/DamAssets';
import Axios, { header } from 'functions/Axios';
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import MoveToAssetDesign from './MoveToAssetDesign';
import AddToCollectionCommonModal from './AddToCollection';
import ShareAssetSection from './ShareAsset';
import { Deletemodel } from 'Common/Deletemodel';
import { useDownloadAssets } from 'context/DownloadAssetsContext';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';
import { DAM_API_URL } from 'Constant';
const SelectionActions = ({
  handleDelete,
  selectedCount,
  downloadImages,
  collectiondataadd,
  HandleAssetMove,
  shareMultipleAsset,
  HandleFolderCreation,
  trash,
}) => {
  const { selectedAssets, selectedFolders } = useSelector((state) => state.dam);
  const [addcollection, setaddcollection] = useState(false);
  const [datacollection, setDatacollection] = useState();
  const [movetoModal, setMovetoModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const hasDAMAccess = useHasAccess(MODULE_IDS.DAM);
  const hasDAMFullAccess = useHasAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]);

  const { startDownload } = useDownloadAssets();

  const [deleteModalContent, setDeleteModalContent] = useState({
    Header: 'Delete',
    Content: 'Are you sure you want to delete?',
    isCloseButton: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);

  const countValue = hasDAMFullAccess
    ? (selectedAssets?.filter((item) => item?.isSelected)?.length ?? 0) +
      (selectedFolders?.filter((item) => item?.isSelected)?.length ?? 0)
    : (selectedAssets?.filter((item) => item.isSelf)?.filter((item) => item?.isSelected)?.length ??
        0) +
      (selectedFolders?.filter((item) => item.isSelf)?.filter((item) => item?.isSelected)?.length ??
        0);
  const deletedHandler = async () => {
    var deleteFolderIds = [];
    var deleteFileIds = [];

    if (hasDAMFullAccess) {
      deleteFileIds = selectedAssets
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.damFileId ?? item?.assetId);
      deleteFolderIds = selectedFolders
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.id);
    } else if (hasDAMAccess) {
      deleteFileIds = selectedAssets
        ?.filter((item) => item?.isSelected)
        ?.filter((item) => item.isSelf)
        ?.map((item) => item?.damFileId ?? item?.assetId);
      deleteFolderIds = selectedFolders
        ?.filter((item) => item?.isSelected)
        ?.filter((item) => item.isSelf)
        ?.map((item) => item?.id);
    }

    try {
      setDeleteLoading(true);
      setTimeout(() => {
        setOpenDeleteModal(false);
      }, 4000);
      const result = await Axios.post(trash ? DELETE_ASSETS_FOR_EVER : DELETE_MULTIPLE_ASSET, {
        fileId: deleteFileIds,
        folderId: deleteFolderIds,
      });
      setOpenDeleteModal(false);
      setDeleteLoading(false);
      toast.success(result?.data?.message || 'Deleted Successfully');

      handleDelete && handleDelete();
    } catch (error) {
      setOpenDeleteModal(false);
      setDeleteLoading(false);
      console.error(error);
    }
  };

  const downloadHandler = async () => {
    try {
      var _data = {
        fileId: selectedAssets
          ?.filter((item) => item?.isSelected)
          ?.map((item) => item?.damFileId ?? item?.assetId),
        folderId: selectedFolders?.filter((item) => item?.isSelected)?.map((item) => item?.id),
      };

      await startDownload(_data);
    } catch (error) {
      console.error(error);
      const customMessage = error?.response?.headers['x-custom-message'];

      if (customMessage) {
        // toast.error(customMessage);
        setOpenDeleteModal(true);
        setDeleteModalContent({
          Header: 'Warning',
          Content: customMessage,
          isCloseButton: true,
        });
      }
    }
  };

  const fetchCollection = async () => {
    try {
      const response = await Axios.get(ListofCollectionsURL + `?pageNo=${0}&rowSize=20`);
      if (!response.data.errorStatus) {
        setDatacollection(response?.data?.data?.collections);
      } else {
        // Handle error
      }
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchCollection();
  }, []);

  async function handleRestore() {
    var deleteFolderIds = [];
    var deleteFileIds = [];

    if (hasDAMFullAccess) {
      deleteFileIds = selectedAssets
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.damFileId ?? item?.assetId);
      deleteFolderIds = selectedFolders
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.id);
    } else if (hasDAMAccess) {
      deleteFileIds = selectedAssets
        ?.filter((item) => item?.isSelected)
        ?.filter((item) => item.isSelf)
        ?.map((item) => item?.damFileId ?? item?.assetId);
      deleteFolderIds = selectedFolders
        ?.filter((item) => item?.isSelected)
        ?.filter((item) => item.isSelf)
        ?.map((item) => item?.id);
    }

    try {
      const result = await Axios.post(`${DAM_API_URL}/apidam/restore-delete-asset`, {
        fileId: deleteFileIds,
        folderId: deleteFolderIds,
      });
      handleDelete && handleDelete();
    } catch (error) {
      console.error(error);
    }
  }

  console.log('selectedAssets', selectedAssets);
  return (
    <Fragment>
      {addcollection && (
        <AddToCollectionCommonModal
          openModal={addcollection}
          Data={[
            ...(selectedAssets?.filter((item) => item?.isSelected)?.map((item) => item?.damFileId) ||
              []),
            ...(selectedFolders?.filter((item) => item?.isSelected)?.map((item) => item?.id) || []),
          ]}
          ToggleModal={() => {
            setaddcollection(!addcollection);
          }}
        />
      )}

      {openDeleteModal && (
        <Deletemodel
          deletemodal={openDeleteModal}
          toggledelete={() => {
            setOpenDeleteModal(!openDeleteModal);
          }}
          handleDelete={deletedHandler}
          loading={deleteLoading}
          Header={`${trash ? 'Delete permanently' : 'Move to trash'}`}
          Content={`${trash ? `Are you sure you want to Delete?` : `Asset will be deleted after 30 days?`}`}
          isCloseButton={deleteModalContent?.isCloseButton}
        />
      )}

      {movetoModal && !trash && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          Data={[
            ...(selectedAssets?.filter((item) => item?.isSelected)?.filter((item) => item.isSelf).map((item) => item?.damFileId) ||
              []),
            ...(selectedFolders?.filter((item) => item?.isSelected)?.filter((item) => item.isSelf).map((item) => item?.id) || []),
          ]}
          HandleAssetMove={() => {
            HandleAssetMove && HandleAssetMove();
          }}
          HandleFolderCreation={() => {
            HandleFolderCreation && HandleFolderCreation();
          }}
          isMultiple={true}
        />
      )}

      {shareModal && !trash && (
        <ShareAssetSection
          openModal={shareModal}
          ParentId={[
            ...(selectedAssets
              ?.filter((item) => item?.isSelected)
              .map((item) => item?.damFileId ?? item?.assetId) || []),
            ...(selectedFolders?.filter((item) => item?.isSelected).map((item) => item?.id) || []),
          ]}
          toggleOpenModal={() => {
            setShareModal(!shareModal);
          }}
        />
      )}
      <div className="d-flex width-fit-content">
        {countValue > 0 && hasDAMAccess && trash && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
            onClick={() => {
              handleRestore();
            }}
          >
            {/* <img src={deleteicon} alt="Delete Icon" /> */}
            {DAM_SVG.restoreIcon}
            <div
              className="text-red"
              style={{
                color: '#753cb7',
              }}
            >
              Restore({countValue})
            </div>
          </div>
        )}
        {countValue > 0 && hasDAMAccess && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
            onClick={() => {
              setOpenDeleteModal(true);
              setDeleteModalContent({
                Header: 'Delete',
                Content: 'Are you sure you want to delete?',
                isCloseButton: false,
              });
            }}
          >
            {/* <img src={deleteicon} alt="Delete Icon" /> */}
            {DAM_SVG.redDeleteIconSvgComponent}
            <div
              className="text-red"
              style={{
                color: '#BE5454',
              }}
            >
              {`${trash ? `Delete (${countValue})` : ` Move to trash(${countValue})`}`}
            </div>
          </div>
        )}
        {hasDAMAccess && !trash && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
            onClick={() => {
              setMovetoModal(!movetoModal);
            }}
          >
            {/* <img src={deleteicon} alt="Delete Icon" /> */}
            {DAM_SVG.moveIconSvg}
            <div
              style={{
                color: '#753CB7',
              }}
            >
              Move ({countValue})
            </div>
          </div>
        )}

        {countValue > 0 &&  !trash && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
            onClick={downloadHandler}
          >
            {DAM_SVG.inheritDownloadIcons}
            <div
              className=""
              style={{
                color: '#753CB7',
              }}
            >
              Download({countValue})
            </div>
          </div>
        )}

        {
          selectedFolders?.filter((item) => item?.isSelected)?.length === 0 &&
          !trash && (
            <div
              className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
              onClick={() => {
                setaddcollection(true);
                collectiondataadd && collectiondataadd();
              }}
            >
              {DAM_SVG.addiitonSvgIcon}
              <div
                className=""
                style={{
                  color: '#753CB7',
                }}
              >
                Add to Collection
              </div>
            </div>
          )}
        {!trash && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Primary-Button large-button"
            style={{
              opacity: hasDAMAccess ? 1 : 0.5,
              cursor: 'pointer',
              cursor: hasDAMAccess ? 'pointer' : 'not-allowed',
            }}
            onClick={() => {
              if (hasDAMAccess) setShareModal(!shareModal);
            }}
          >
            {DAM_SVG.shareIconSvgComponent}
            <div className="">Share</div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default SelectionActions;
